export enum RequestsFilteringGroups {
    Status = 'status',
    Type = 'type',
    Source = 'source',
    Domain = 'domain',
    Country = 'country',
    Brand = 'brand',
    Rights = 'rights',
    MinCreatedAt = 'minCreatedAt',
    Assignee = 'assignee',
    DueDate = 'dueDate',
    ForReview = 'forReview',
    StateOfResidence = 'stateOfResidence',
    DataSubjectType = 'dataSubjectType',
    DataSubjectTypeLabel = 'dataSubjectTypeLabel',
    MinVerifiedAt = 'minVerifiedAt',
    ClosingReason = 'closingReason',
    ReadStatus = 'ReadStatus', // old category, moved to "for review", save for backward compatibility
    Errors = 'errors', // old category, moved to "for review", save for backward compatibility
}

export enum AssigneeFilter {
    None = 'none'
}

export enum ForReviewFilter {
    AutopilotError = 'aperror',
    Unread = 'Unread',
    RequireAttention = 'RequireAttention',
    UnreadNewRequests = 'UnreadNewRequests',
    UnreadNewResponses = 'UnreadNewResponses',
}